import { PaginationStateProps } from 'common/state/types';
import { ClientTransfer, ClientTransferRequest } from './actions';

// #region ClientTransfer
export interface ClientTransfersState extends PaginationStateProps {
  pending: boolean;
  transfers: ClientTransfer[] | null;
  error?: string;
}

export const defaultClientTransfersState: ClientTransfersState = {
  pending: false,
  transfers: null,
  error: null,
  count: 0,
  next: null,
  previous: null,
};
// #endregion

// #region ClientTransferRequest
export interface ClientTransferRequestsState extends PaginationStateProps {
  pending: boolean;
  requests: ClientTransferRequest[] | null;
  error?: string;
}

export const defaultClientTransferRequestsState: ClientTransferRequestsState = {
  pending: false,
  requests: null,
  error: null,
  count: 0,
  next: null,
  previous: null,
};
// #endregion
